exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */.cancellation-title{color:#3f3d3d;text-decoration:underline}[dir] .policy-mark{cursor:pointer}.fa-question-circle{font-size:16px}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/reservation-policies/reservation-policies.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/reservation-policies/reservation-policies.component.scss
// module chunks = 0